export default __webpack_public_path__ + "img/right1.172a6233.jpg";